import bulmaCollapsible from '@creativebulma/bulma-collapsible';
import { discountStore } from './store/discountStore.js';
import { userStore } from './store/userStore.js';
import mixin from './mixin';

const catalogDetailApp = {
    mixins: [mixin],
    data() {
        return {
            userApi: '',
            itemApi: '',
            discountUrl: '',
            startUrl: '',
            culture: 'nl-NL',
            item: [],
            purchaseApi: '',
            purchaseError: false,
            price: null,
            modifier: {
                fixed: 'Fixed',
                percentual: 'Percentual'
            },
            isFree: false,
            isPayed: false,
            isViewable: false,
            isAvailable: true,
            isExpired: false,
            isPending: false,
            isLivestream: false,
            availableFrom: new Date().toISOString(),
            availableUntil: new Date().toISOString(),
            isFavourite: false,
            loadFavourites: false,
            loadPayment: false,
            loading: false,
            preminutes: 0,
        }
    },
    computed: {
        discount() {
            return discountStore.state;
        },
        user() {
            return userStore.user;
        },
        loggedIn() {
            return userStore.loggedIn;
        }
    },
    methods: {
        async init() {
            this.loading = true;

            const itemResponse = await this.fetchApiData(this.itemApi, '', 'get');
            if (itemResponse && itemResponse.status === 200) {
                this.item = itemResponse.data ? itemResponse.data : [];
            }

            if (this.loggedIn) {
                if (Array.isArray(this.user.purchasedVodItems) && this.user.purchasedVodItems.length) {
                    if (this.user.purchasedVodItems.some(p => p === this.item.id)) {
                        this.isViewable = true;
                        this.isPayed = true;
                    }
                }
                this.favourites = this.user.favouriteVodItems;
                if (Array.isArray(this.user.favouriteVodItems) && this.user.favouriteVodItems.length) {
                    if (this.user.favouriteVodItems.some(f => f === this.item.id)) {
                        this.isFavourite = true;
                    }
                }
            }
            if (this.item.availability) {
                const now = new Date();
                this.isAvailable = this.item.availability.isViewableCurrently;
                this.isPending = this.item.availability.isViewableInFuture;
                this.isExpired = this.item.availability.wasViewableInPast;
                this.availableFrom = new Date(this.item.availability.viewableStart);
                if (this.availableFrom && this.isLivestream && this.preminutes > 0) {
                    this.availableFrom = new Date(
                        this.availableFrom.getTime() - this.preminutes * 60 * 1000
                    );
                }
                if (now >= this.availableFrom) {
                    this.isPending = false;
                }
                this.availableEnd = this.item.availability.viewableEnd;
                this.price = this.item.availability.price ? this.item.availability.price.amount : 0;
            }
            this.isFree = this.price === 0;

            if (this.isFree || this.isPayed) {
                this.isViewable = true;
            }
            this.availableFrom = this.availableFrom.toLocaleDateString('nl-NL', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
            this.availableEnd = new Date(this.availableEnd).toLocaleDateString('nl-NL', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
            this.loading = false;
            this.$nextTick(() => {
                const widgetVidcontrol = document.querySelectorAll('.widget-video-wrapper');
                widgetVidcontrol.forEach((vidcontrol) => {
                    const type = vidcontrol.dataset.type;
                    const play = vidcontrol.querySelector('.is-play');
                    const preview = vidcontrol.querySelector('.widget-video-image');
                    const video = vidcontrol.querySelector('.widget-video-video');

                    vidcontrol.addEventListener('click', (e) => {
                        e.preventDefault();
                        preview.classList.remove('is-active');
                        play.classList.remove('is-active');
                        video.classList.add('is-active');
                        if (type === 'youtube') video.setAttribute('src', video.dataset.src);
                        setTimeout(() => {
                            if (type === 'youtube') {
                                video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
                            } else {
                                video.contentWindow.postMessage('{"method":"play"}', '*');
                            }
                        }, 500);
                    });
                });

                const bulmaCollapsibleInstancesVue = bulmaCollapsible.attach('.is-collapsible--vue');

                bulmaCollapsibleInstancesVue.forEach(bulmaCollapsibleInstance => {
                    bulmaCollapsibleInstance.on('after:expand', function () {
                        bulmaCollapsibleInstance._originalHeight = bulmaCollapsibleInstance.element.scrollHeight + 'px';
                    });
                });
            });
        },
        async toggleFavourite() {
            this.loadFavourites = true;
            let url = this.favouritesApi + '/' + this.item.id;
            if (this.isFavourite) {
                const response = await this.fetchApiData(url, '', 'delete');
                if (response.status === 200 && response.data) {
                    this.user.favouriteVodItems = this.user.favouriteVodItems.filter(fav => {
                        return fav !== this.item.id;
                    });
                    this.isFavourite = false;
                }
            } else {
                const response = await this.fetchApiData(url, '', 'put');
                if (response.status === 200 && response.data.typeAlias === 'Success') {
                    this.user.favouriteVodItems.push(this.item.id);
                    this.isFavourite = true;
                }
            }
            userStore.updateUser(this.user);
            this.loadFavourites = false;
        },
        replacePrice(text) {
            return text.replace('{price}', new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(this.price))
        },
        async resolvePayment(loginPage) {
            if (this.loggedIn) {
                this.loadPayment = true;
                let discountArray = [];
                let foundDiscount = this.discount.find(discount => discount.forProductId === this.item.id);
                if (foundDiscount) {
                    discountArray.push(foundDiscount.id);
                }
                let query = {
                    'ProductID': this.item.id,
                    'StartUrl': this.startUrl,
                    'DiscountCodes': discountArray,
                    'LanguageID': this.culture
                };
                const payResponse = await this.fetchApiData(this.purchaseApi, query, 'post');
                if (payResponse) {
                    if (payResponse.status === 200 && payResponse.data) {
                        if (payResponse.data.success) {
                            if (payResponse.data.paymentUrl) {
                                window.location.href = payResponse.data.paymentUrl;
                            } else {
                                this.purchaseError = true;
                            }
                        } else {
                            this.purchaseError = true;
                        }
                    } else {
                        this.purchaseError = true;
                    }
                } else {
                    this.purchaseError = true;
                }
                this.loadPayment = false;
            } else {
                window.location.href = loginPage;
            }
        },
        hasDiscount(id) {
            return this.discount.filter(discount => discount.forProductId === id).length;
        },
        discountPrice(price, id) {
            let foundDiscount = this.discount.find(discount => discount.forProductId === id);
            if (foundDiscount && foundDiscount.priceModifier) {
                let priceNumeric = parseFloat(price);
                let modifier = parseFloat(foundDiscount.priceModifier);
                return foundDiscount.priceModifierTypeAlias === this.modifier.percentual ? this.toDutchCurrency(priceNumeric * modifier) : this.toDutchCurrency(priceNumeric + modifier);
            } else {
                return null;
            }
        },
    },
    mounted() {
        let self = this;
        window.addEventListener('memberChanged', (event) => {
            userStore.user = event.detail.user;
            self.favourites = self.user.favouriteVodItems;
            if (Array.isArray(self.user.favouriteVodItems) && self.user.favouriteVodItems.length) {
                if (self.user.favouriteVodItems.some(f => f === self.item.id)) {
                    self.isFavourite = true;
                } else {
                    self.isFavourite = false;
                }
            } else {
                self.isFavourite = false;
            }
        });
        if (this.$el.parentNode.dataset.itemapi) this.itemApi = this.$el.parentNode.dataset.itemapi;
        if (this.$el.parentNode.dataset.favouritesapi) this.favouritesApi = this.$el.parentNode.dataset.favouritesapi;
        if (this.$el.parentNode.dataset.starturl) this.startUrl = this.$el.parentNode.dataset.starturl;
        if (this.$el.parentNode.dataset.culture) this.culture = this.$el.parentNode.dataset.culture;
        if (this.$el.parentNode.dataset.purchaseapi) this.purchaseApi = this.$el.parentNode.dataset.purchaseapi;
        if (this.$el.parentNode.dataset.percentual) this.modifier.percentual = this.$el.parentNode.dataset.percentual;
        if (this.$el.parentNode.dataset.fixed) this.modifier.fixed = this.$el.parentNode.dataset.fixed;
        if (this.$el.parentNode.dataset.isLivestream) this.isLivestream = this.$el.parentNode.dataset.isLivestream === 'True' ? true : false;
        if (this.$el.parentNode.dataset.preminutes) this.preminutes = parseInt(this.$el.parentNode.dataset.preminutes);
        this.init();
    }
}

export default catalogDetailApp;
